"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const upload_1 = require("./fivopla/upload");
($ => {
    new upload_1.Upload($('#standaloneUpload'));
})(jQuery);
